export const PA_T01 = '임시저장 되었습니다.';
export const PA_T02 = '저장 되었습니다.';

export const PA_A01 = '검색기간은 1년을 초과할 수 없습니다.';
export const PA_A02 = '현재까지 입력한 내용을 저장합니다.';
export const PA_A03 = '제목은 필수입력 항목입니다.';
export const PA_A04 = '필수입력사항을 모두 등록해야 미리보기가 가능합니다.';
export const PA_A05 = '상품그룹이 복합상품그룹인 경우 기획전그룹은 2개 이상 등록이 필요합니다.';
export const PA_A06 = '메인카테고리는 1개만 선택가능합니다.';
export const PA_A07 = '서브카테고리는 10개까지만 선택가능합니다.';
export const PA_A08 = '그룹정보를 입력 후 반영버튼을 클릭해주시기 바랍니다.';
export const PA_A09 = '등록된 상품이 없습니다. 상품을 추가해주시기 바랍니다.';
export const PA_A10 = '기획전 및 이벤트는 최소 2개 이상 등록해야 합니다.';
export const PA_A11 = '선택된 기획전이 없습니다.';
export const PA_A12 = '기획전/이벤트가 20개를 초과하여 등록할 수 없습니다.';
export const PA_A13 = '선택된 이벤트가 없습니다.';
export const PA_A14 = '해당 사이트/계열사는 기획전 대상이 아닙니다.';
export const PA_A15 = '사이트 및 계열사를 선택해주시기 바랍니다.';
export const PA_A16 = '배너는 최소 2개 이상 등록해야 합니다.';
export const PA_A17 = '배너그룹은 2개 이상 등록해야 합니다.';

export const PA_C01 = '등록(변경)한 내용을 저장하지 않고 이동하시겠습니까?';
export const PA_C02 = '입력한 내용을 저장하지 않고 취소하시겠습니까?';
export const PA_C03 = '삭제하시겠습니까?';
export const PA_C04 = '최소 6개 이상 상품등록을 해야 메인페이지에 정상적으로 노출됩니다. 정말로 저장하시겠습니까?';
export const PA_C05 = '등록된 내용이 모두 지워집니다. 유형을 변경하시겠습니까?';
export const PA_C06 = '입력된 내용을 저장하지 않고 취소하시겠습니까?';
export const PA_C07 = '입력한 내용을 저장하지 않고 단일기획전 화면으로 이동하시겠습니까?';
export const PA_C08 = '선택한 기획전의 상태를 사용으로 일괄변경 하시겠습니까?';
export const PA_C09 = '선택한 기획전의 상태를 미사용으로 일괄변경 하시겠습니까?';
export const PA_C10 = '선택한 기획전의 상태를 전시로 일괄 변경하시겠습니까?';
export const PA_C11 = '선택한 기획전의 상태를 미전시로 일괄 변경하시겠습니까?';

export const MAIN_DISPLAY_INVALID_MSG = '통합기획전은 메인전시가 불가합니다. 제외 후 다시 변경해주세요.';
export const CHANGE_COMPLETE_MSG = '완료되었습니다.';

export const TEMP_SAVE_CONFIRM_MSG = '임시저장하시겠습니까?';
export const SAVE_CONFIRM_MSG = '저장하시겠습니까?';
